exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3w8I3{min-width:200px;width:100%}", ""]);

// exports
exports.locals = {
	"timeSelector": "_3w8I3"
};